export default function ReparerPlutot() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="bg-white rounded-xl border border-brand-border p-6 md:p-8">
          <h2 className="text-xl md:text-2xl font-bold text-brand-blue mb-4 flex items-center gap-3">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-cyan/10 text-brand-cyan">
              <i className="ri-heart-pulse-line"></i>
            </span>
            Réparer plutôt que remplacer
          </h2>
          <p className="text-brand-text leading-relaxed mb-4">
            Une manivelle qui tourne dans le vide ne signifie pas forcément que le mécanisme entier est à changer. Dans de nombreux cas, seul le cardan est déboîté, la sortie de caisson est légèrement usée, ou un ressort de rappel est détendu. Notre politique est simple : diagnostiquer avant de remplacer, et proposer la réparation la plus économique et la plus durable.
          </p>
          <p className="text-brand-text leading-relaxed">
            Lors de notre passage à Strasbourg ou dans le Bas-Rhin, nous démontons la manivelle, inspectons le treuil à l'endoscope si nécessaire, et testons chaque composant de transmission. Si une simple réparation suffit (resserrage, graissage, repositionnement du cardan), nous le faisons. Si le remplacement est inévitable, nous vous expliquons pourquoi et nous vous proposons des pièces neuves garanties. Devis gratuit et transparent avant tout travail.
          </p>
        </div>
      </div>
    </section>
  );
}